import { IconWrapper } from '../runtime';
export default IconWrapper('folder_shared_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M1.5 13.5C0.671573 13.5 0 12.8284 0 12L0 1.5C0 0.671573 0.671573 0 1.5 0L4.5 0C4.82456 0 5.14036 0.105267 5.4 0.3L6.6 1.2C6.85964 1.39473 7.17544 1.5 7.5 1.5L14.5 1.5C15.3284 1.5 16 2.17157 16 3L16 12C16 12.8284 15.3284 13.5 14.5 13.5L1.5 13.5Z",
      "fill": "#0065DC"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.5 15C0.671573 15 0 14.3284 0 13.5L0 4.5C0 3.67157 0.671573 3 1.5 3L14.5 3C15.3284 3 16 3.67157 16 4.5L16 13.5C16 14.3284 15.3284 15 14.5 15L1.5 15Z",
      "fill": "#1983FF"
    }
  }), h("path", {
    "attrs": {
      "d": "M9.97727 7.54545C10.6802 7.54545 11.25 6.97564 11.25 6.27273C11.25 5.56982 10.6802 5 9.97727 5C9.27436 5 8.70455 5.56982 8.70455 6.27273C8.70455 6.31982 8.7071 6.36631 8.71209 6.41208L6.95097 7.36037C6.66433 7.08112 6.27271 6.90909 5.84091 6.90909C4.96227 6.90909 4.25 7.62137 4.25 8.5C4.25 9.37863 4.96227 10.0909 5.84091 10.0909C6.27262 10.0909 6.66418 9.91895 6.95081 9.63979L8.71206 10.5882C8.70709 10.6338 8.70455 10.6803 8.70455 10.7273C8.70455 11.4302 9.27436 12 9.97727 12C10.6802 12 11.25 11.4302 11.25 10.7273C11.25 10.0244 10.6802 9.45455 9.97727 9.45455C9.66832 9.45455 9.38507 9.56463 9.16463 9.74772L7.40367 8.79951C7.42215 8.70251 7.43182 8.60238 7.43182 8.5C7.43182 8.3977 7.42216 8.29765 7.40371 8.20072L9.16481 7.25243C9.38523 7.43543 9.6684 7.54545 9.97727 7.54545Z",
      "fill": "white"
    }
  })]);
});